/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-default */
import { default as EVENT_TYPES } from './event-types';
import { default as DISPLAY_FIELDS } from './display-fields';

export * from './actions';
export * from './exposed-methods';
export * from './feature-flags';
export * from './feature-gates';
export * from './flows';
export * from './hint-states';
export * from './hint-types';
export * from './item-types';
export * from './services';
export * from './ppv-resource-types';
export * from './new-person-hints';
export * from './source-types';
export * from './suggestions';
export * from './trees';
export * from './relationship-types';
export * from './authz-access-types';
export * from './experiments';
export * from './input-limits';
export { SubFlows } from './ube';

export { EVENT_TYPES, DISPLAY_FIELDS };
export const STACK_ID = 'hintsui-eval';

// Full-page merge-ui related
// Notes: blade_fullpage_merge experiment (variant1 & variant2 support)
export const FULL_PAGE_ALLOWED_VARIANTS = new Set(['1', '2']);

export const NEWSPAPER_DATABASE = '61843';

export const MAX_LEAF_ICON_SIZE = 3;
// Notes: https://ancestry.slack.com/archives/C07NZMHBTG9/p1727134154824599
export const FREE_TRIAL = 'neft';

export const PRIMARY_NODE_ID = '1:99';
export const RELATIONSHIP_EVENTS = ['Marriage', 'Divorce'];

export const TEST = 'test';
export const VARIANT1 = 'variant1';

export const SUB = 'sub';

export const FCI_ERROR_TYPE = {
	ACTION: 'Action',
	EMPTY_CONTENT: 'Empty Content',
	MISSING_ELEMENT: 'Missing Element',
	MISSING_SUPPLEMENTAL_CONTENT: 'Missing Supplemental Content'
};
